/* eslint-disable no-console */
import { Faro, LogLevel } from '@grafana/faro-web-sdk';

import { isNonProdEnv } from '@cccom/shared/utils/common';

declare const window: Window & { faro?: Faro };
const faroInstance = window?.faro;
const isNonProd = isNonProdEnv();

/* 
   faro expects errors in a certain format but sometimes we only 
   return a string and optionally an error object of unknown type.
   This function just converts whatever is passed in to the format 
   faro expects. 
*/
const transformErrorForFaro = (message: string, error: unknown) => {
  if (!error) return new Error(message);

  return {
    message,
    name: message.split(':')[0],
    ...error,
  };
};

export const log = {
  log: (message: string, ...optionalParams: any[]) => {
    if (isNonProd) console.log(message, ...optionalParams);

    if (faroInstance)
      faroInstance.api.pushLog([message], { level: LogLevel.LOG });
  },
  info: (message: string, ...optionalParams: any[]) => {
    if (isNonProd) console.info(message, ...optionalParams);

    if (faroInstance)
      faroInstance.api.pushLog([message], { level: LogLevel.INFO });
  },
  warn: (message: string, ...optionalParams: any[]) => {
    if (isNonProd) console.warn(message, ...optionalParams);

    if (faroInstance)
      faroInstance.api.pushLog([message], { level: LogLevel.WARN });
  },
  error: (message: string, ...errors: unknown[]) => {
    if (isNonProd) console.error(message, errors);

    errors.forEach(
      (error) =>
        faroInstance &&
        faroInstance.api.pushError(transformErrorForFaro(message, error))
    );
  },
};
